import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useEffect, useState } from 'react';
import EcoCountDown from 'eco-design-components/elements/eco-count-down';
import { useRouter } from 'next/router';
import { useProductCountdownEnd } from '../../ProductProvider';
import EcoLink from 'eco-design/base/eco-link';
import EcoImg from 'eco-design/base/eco-img';
import Modal from './Modal';
import ModalItems from './ModalItems';
import { createPortal } from 'react-dom';
import gtm from '@/utils/gtm';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import { baseUrl } from 'lowcode/utils/service/baseUrl';
import { getEmailConfigs } from './emailConfigs';
import { useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';

interface ModalItem {
    title: string;
    lists: {
        img: string;
        name?: string;
        text: string;
    }[];
    tip: string;
    btn?: {
        btnText: string;
        btnLink?: string;
    };
}
interface ItemType {
    text: string;
    img: string[];
    modal: ModalItem;
    key: number;
}
const D: React.FC<{ setActivetedTabs: any }> = ({ setActivetedTabs }) => {
    const pageStatus = useProductPageStatus();
    const { t } = useLang('dpux');
    const { locale = 'us' } = useRouter();
    const [input, setInput] = useState('');
    const [checked, setChecked] = useState(false);
    const [tip, setTip] = useState('');
    const [visible, setVisible] = useState(false);
    const [visibleItems, setVisibleItems] = useState(-1);
    const [isClient, setIsClient] = useState(false);
    const countDownEnd = useProductCountdownEnd();

    const termsMap: { [key: string]: string[] } = {
        us: ['https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html'],
        ca: ['https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html'],
        jp: ['https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html'],
        eu: ['https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html'],
        uk: ['https://account.ecoflow.com/agreement/en-ul/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html'],
        de: ['https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/de-de/TermsOfUse.html'],
        fr: ['https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html'],
        it: ['https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/it-it/TermsOfUse.html'],
        es: ['https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/es-es/TermsOfUse.html'],
    };

    // 第一个阶段
    let items: ItemType[] = [
        {
            text: t(`D_item1_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737187/1.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000982471/pc_benifit_01.svg',
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001320599/768_light_%E4%BE%A7%E6%BB%91.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760001043076/m_benifit_01.svg',
            ],
            modal: {
                title: t(`D_item1_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153252/d_list1_1.png',
                        text: t(`D_item1_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item1_modal_tip_${pageStatus?.toLowerCase()}`),
                btn: {
                    btnText: t(`D_item1_modal_btn_text_${pageStatus?.toLowerCase()}`),
                    btnLink: t(`D_item1_modal_btn_link_${pageStatus?.toLowerCase()}`),
                },
            },
            key: 0,
        },
        {
            text: t(`D_item2_text_${pageStatus?.toLowerCase()}`),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1760000982224/pc_benifit_02.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042485/m_benifit_02.svg',
            ],
            modal: {
                title: t(`D_item2_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153436/d_list3_1.png',
                        text: t(`D_item2_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item2_modal_tip_${pageStatus?.toLowerCase()}`),
                btn: {
                    btnText: t(`D_item2_modal_btn_text_${pageStatus?.toLowerCase()}`),
                    btnLink: t(`D_item2_modal_btn_link_${pageStatus?.toLowerCase()}`),
                },
            },
            key: 1,
        },
        {
            text: t(`D_item3_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737557/2.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000981994/pc_benifit_03.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042758/m_benifit_03.svg',
            ],
            modal: {
                title: t(`D_item3_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357214350/d_list2_1.png',
                        name: t(`D_item3_modal_name1_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item3_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1758357153609/d_list2_2.png',
                        name: t(`D_item3_modal_name2_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item3_modal_text2_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item3_modal_tip_${pageStatus?.toLowerCase()}`),
            },
            key: 2,
        },
        {
            text: t(`D_item4_text_${pageStatus?.toLowerCase()}`),
            img: [
                locale === 'ca'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1760001737457/3.svg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1760000981748/pc_benifit_04.svg',
                'https://websiteoss.ecoflow.com/upload/image/1760001042281/m_benifit_04.svg',
            ],
            modal: {
                title: t(`D_item4_modal_title_${pageStatus?.toLowerCase()}`),
                lists: [
                    {
                        img: 'https://websiteoss.ecoflow.com/upload/image/1757916708647/d4.svg',
                        name: t(`D_item4_modal_name1_${pageStatus?.toLowerCase()}`),
                        text: t(`D_item4_modal_text1_${pageStatus?.toLowerCase()}`),
                    },
                ],
                tip: t(`D_item4_modal_tip_${pageStatus?.toLowerCase()}`),
            },
            key: 3,
        },
    ];
    if (locale === 'ca') {
        items = [items[0], items[2], items[3]];
        items[1].modal.lists.shift();
    }

    // 第二个阶段
    if ([IPageStatus.SUPER_EARLY].includes(pageStatus)) {
        if (locale === 'ca') {
            items = [items[0], items[2]];
        } else {
            items[2].modal.lists[1].img = 'https://websiteoss.ecoflow.com/upload/image/1758357831874/d_list3_2.png';
            items[2].modal.lists.push({
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357832034/d_list3_3.png',
                name: t(`D_item3_modal_name3_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text3_${pageStatus?.toLowerCase()}`),
            });
        }
    }

    // 第三个阶段
    if (pageStatus === IPageStatus.EARLY) {
        items[2].modal.lists = [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357831874/d_list3_2.png',
                name: t(`D_item3_modal_name2_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text2_${pageStatus?.toLowerCase()}`),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1758357832034/d_list3_3.png',
                name: t(`D_item3_modal_name3_${pageStatus?.toLowerCase()}`),
                text: t(`D_item3_modal_text3_${pageStatus?.toLowerCase()}`),
            },
        ];
        items[2].img[0] = 'https://websiteoss.ecoflow.com/upload/image/1758356493927/768_light_1svg.svg';
        items[3].img[0] = 'https://websiteoss.ecoflow.com/upload/image/1758356493754/768_light_2.svg';
        items.shift();
        items.shift();
    }

    // 第四个阶段直接隐藏该模块

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value.trim());
    };

    const handleFoucus = () => {
        if ([t('D_tip_success'), t('D_tip_email_format'), t('D_tip_email_empty')].includes(tip)) {
            setTip('');
        }
    };

    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
        if ([t('D_tip_success'), t('D_tip_unchecked')].includes(tip)) {
            setTip('');
        }
        setChecked(e.target.checked);
    };

    const handleSubmit = async () => {
        const emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        const email = input.trim();
        if (!email) {
            return setTip(t('D_tip_email_empty'));
        }
        if (!emailReg.test(email)) {
            return setTip(t('D_tip_email_format'));
        }
        if (!checked) {
            return setTip(t('D_tip_unchecked'));
        }

        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        const emailConfig = getEmailConfigs(dateString);
        const { contactListId, fields } = emailConfig[locale as keyof typeof emailConfig] || emailConfig['us'];
        const res = await fetchPost(
            `${baseUrl(locale)}/subscribe/new`,
            locale,
            {
                contactListId: contactListId[0],
                email,
                fields,
                source: 'WEB_NEW_PRODUCT_SUB',
                otherContactListIds: contactListId.slice(1),
                eventTracking: subscribeCookie({
                    sector_name: t('D_btn'),
                    entry_position: 4,
                }),
            },
            {
                headers: {
                    apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
                },
            },
        );
        if (res?.code === '0') {
            setTip(t('D_tip_success'));
            setInput('');
            setTimeout(() => {
                setTip('');
            }, 3000);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('D_btn'),
                status: 'success',
                product_name: 'EcoFlow DELTA Pro Ultra',
                tag: 'Agree',
                __btn_id1: css.section,
                __btn_id2: t('D_btn'),
            });
        } else {
            setTip(t('D_tip_fail'));
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('D_btn'),
                status: 'fail',
                tag: 'Agree',
                product_name: 'EcoFlow DELTA Pro Ultra',
                __btn_id1: css.section,
                __btn_id2: t('D_btn'),
            });
            throw new Error(res?.message);
        }
    };

    const handleOpenModal = () => {
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('title'),
            button_name: t('D_memo'),
            __btn_id1: css.section,
            __btn_id2: t('D_memo'),
        });
    };

    const handleCloseModal = () => {
        setVisible(false);
    };

    const handleCloseItems = () => {
        setVisibleItems(-1);
    };

    const handleClickItem = (item: ItemType, k: number) => {
        setVisibleItems(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: item.text,
            button_name: '?',
            __btn_id1: css.section,
            __btn_id2: `${'? | '}${item.text}`,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
            const sceneDArr: any[] = [];
            const title = document.querySelector('.delta-pro-ultra-x-D .title-ani');
            const countdown = document.querySelector('.delta-pro-ultra-x-D .countdown-ani');
            const control = document.querySelector('.delta-pro-ultra-x-D .control-ani');
            const items = document.querySelectorAll('.delta-pro-ultra-x-D .items-ani .items .item');
            const memo = document.querySelector('.delta-pro-ultra-x-D .memo-ani');

            let timers: any = [];
            sceneDArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-D .info',
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        title && title?.classList.add('enter');
                        countdown && countdown?.classList.add('enter');
                        control && control?.classList.add('enter');
                        items &&
                            items.forEach((item, idx) => {
                                const id = setTimeout(() => {
                                    item.classList.add('enter');
                                }, 600 + 60 * idx);
                                timers.push(id);
                            });
                        memo && memo?.classList.add('enter');
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            title && title?.classList.remove('enter');
                            countdown && countdown?.classList.remove('enter');
                            control && control?.classList.remove('enter');
                            // 清掉所有未执行的 timeout，避免副作用
                            timers.forEach((id: any) => clearTimeout(id));
                            timers = [];
                            items &&
                                items.forEach((item) => {
                                    item.classList.remove('enter');
                                });
                            memo && memo?.classList.remove('enter');
                        }
                    },
                }),
            );
            return () => {
                sceneDArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-D GtmModuleData-section`}
            id="delta-pro-ultra-x-D"
            data-section-id={'delta-pro-ultra-x-D'}
            data-section-title={t(`D_title_${pageStatus?.toLowerCase()}`)}
        >
            <div className="info">
                <div className="title-ani">
                    <p className={`title`}>{t(`D_title_${pageStatus?.toLowerCase()}`)}</p>
                </div>
                <div className="countdown-ani">
                    <div className={`countdown`}>
                        <EcoCountDown endTime={countDownEnd} />
                        <ul className="suffix-items">
                            {['d', 'h', 'm', 's'].map((item) => (
                                <li className="suffix-item" key={item}>
                                    <p className="suffix">{t(`D_countdown_${item}`)}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {[IPageStatus.TEASER, IPageStatus.SUPER_EARLY].includes(pageStatus) && (
                    <div className="control-ani">
                        <div className={`control`}>
                            <div className="subscribe">
                                <input
                                    type="text"
                                    className="input"
                                    id="dpux-D-input"
                                    placeholder={t('D_placeholder')}
                                    value={input}
                                    onChange={handleInput}
                                    onFocus={handleFoucus}
                                />
                                <p className={`tip${tip ? ' show' : ''}${tip === t('D_tip_success') ? ' success' : ''}`}>{tip}</p>
                                <button className="btn" onClick={handleSubmit}>
                                    {t('D_btn')}
                                </button>
                            </div>
                            <div className="terms">
                                <input type="checkbox" className="checkbox" id="dpux-D-checkbox" checked={checked} onChange={handleCheck} />
                                <label className="terms-text" htmlFor="dpux-D-checkbox">
                                    {t.rich('D_terms', {
                                        l1: (termsOfUse: string) => (
                                            <EcoLink href={termsMap[locale][1]} target="_blank">
                                                {termsOfUse}
                                            </EcoLink>
                                        ),
                                        l2: (privacyPolicy: string) => (
                                            <EcoLink href={termsMap[locale][0]} target="_blank">
                                                {privacyPolicy}
                                            </EcoLink>
                                        ),
                                    })}
                                </label>
                            </div>
                        </div>
                    </div>
                )}
                <div className="items-ani">
                    <ul className={`items ${pageStatus.toLowerCase()} ${locale}`}>
                        {items.map((item: any, k: number) => (
                            <li className="item" key={item.text} style={{ gridArea: `g${k + 1}` }} onClick={() => handleClickItem(item, k)}>
                                <EcoImg className="item-img" pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                                <p className="item-text">{item.text}</p>
                                <svg
                                    className="item-icon GtmModuleData-btn-text"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 17.1943C11.4937 17.1943 11.083 17.6051 11.083 18.1113C11.0831 18.6175 11.4938 19.0273 12 19.0273H12.0117C12.5179 19.0273 12.9286 18.6175 12.9287 18.1113C12.9287 17.6051 12.518 17.1943 12.0117 17.1943H12ZM12.6768 5.0332C11.6102 4.85033 10.5131 5.05039 9.58008 5.59863C8.64701 6.147 7.93833 7.00838 7.5791 8.0293C7.41122 8.50682 7.66213 9.03026 8.13965 9.19824C8.61699 9.36577 9.13963 9.11494 9.30762 8.6377C9.52312 8.02511 9.94895 7.50874 10.5088 7.17969C11.0687 6.85065 11.7271 6.73006 12.3672 6.83984C13.0071 6.94967 13.5877 7.28264 14.0059 7.7793C14.424 8.27609 14.6533 8.90537 14.6523 9.55469V9.55566C14.6522 10.291 14.0885 10.9689 13.2275 11.543C12.8248 11.8114 12.4147 12.0175 12.1025 12.1562C11.948 12.2249 11.8202 12.2755 11.7334 12.3086C11.6903 12.325 11.6575 12.3373 11.6367 12.3447C11.6264 12.3484 11.6184 12.3511 11.6143 12.3525H11.6123C11.238 12.4773 10.9854 12.8281 10.9854 13.2227V15.0557C10.9855 15.5618 11.3962 15.9727 11.9023 15.9727C12.4084 15.9725 12.8192 15.5617 12.8193 15.0557V13.8418C12.8284 13.8378 12.8385 13.8351 12.8477 13.8311C13.2229 13.6643 13.7303 13.4109 14.2441 13.0684C15.2161 12.4203 16.4852 11.2642 16.4854 9.55566C16.4866 8.47396 16.1048 7.42624 15.4082 6.59863C14.7112 5.7708 13.7433 5.21621 12.6768 5.0332Z"
                                        fill={`url(#paint0_linear_4220_55133_${k + 1})`}
                                    />
                                    <g opacity="0.8">
                                        <path
                                            d="M8.44336 8.33322C8.73071 7.51637 9.29788 6.82757 10.0444 6.38882C10.791 5.95008 11.6687 5.7897 12.5221 5.93609C13.3756 6.08248 14.1497 6.52619 14.7073 7.18864C15.265 7.85109 15.5702 8.68952 15.5689 9.55544C15.5689 11.9999 11.9022 13.2221 11.9022 13.2221V15.0555"
                                            stroke="white"
                                            stroke-width="1.83333"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M12.0116 17.1943C12.5179 17.1943 12.9283 17.6047 12.9283 18.111C12.9283 18.6173 12.5179 19.0277 12.0116 19.0277H11.9997C11.4934 19.0277 11.083 18.6173 11.083 18.111C11.083 17.6047 11.4934 17.1943 11.9997 17.1943H12.0116Z"
                                            fill="white"
                                        />
                                    </g>
                                    <defs>
                                        <linearGradient id={`paint0_linear_4220_55133_${k + 1}`} x1="7" y1="1" x2="16" y2="22.5" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#617297" />
                                            <stop offset="1" stop-color="#ADBBDB" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="memo-ani">
                    <span className={`memo GtmModuleData-btn-text`} onClick={handleOpenModal}>
                        {`- ${t('D_memo')} -`}
                    </span>
                </div>
            </div>
            {isClient && visible && createPortal(<Modal callback={handleCloseModal} />, document.body)}
            {isClient &&
                visibleItems >= 0 &&
                createPortal(
                    <ModalItems
                        setActivetedTabs={setActivetedTabs}
                        data={items[visibleItems].modal}
                        index={items[visibleItems].key}
                        callback={handleCloseItems}
                    />,
                    document.body,
                )}
        </section>
    );
};

export default D;
